export default {"src":"/developer/_next/static/media/EngAfterLogo.e059fe7f.svg","height":40,"width":98,"blurWidth":0,"blurHeight":0};